export default [
  { header: "Admin" },
  // { icon: "pages", title: "Blank Page", name: "BlankPage" },
  { icon: "business", title: "Manage Organizations", name: "ManageGroups" },
  { icon: "directions_car", title: "Manage Dealerships", name: "ManageDealers" },
  { icon: "account_circle", title: "Manage Users", name: "ManageUsers" },
   { icon: "school", title: "Manage Curriculum", name: "ManageQuestions" },


   {header: "Account Management"},
   { icon: "turned_in", title: "Grade ISM", name: "GradeISM" },
   { icon: "trending_up", title: "Grade Report", name: "GradeReport" },
   // { icon: "pages", title: "Blank Page", name: "BlankPage" },

   {header: "Client Portal"},
   { icon: "account_circle", title: "Manage Users", name: "BlankPage2" },
   { icon: "trending_up", title: "Reporting Dashboard", name: "BlankPage" },

  // { header: "Manage Users" }
  // {
  //   icon: "fas fa-file",
  //   title: "Document",
  //   href: "http://doc-vuse-v1.hexesis.com",
  //   target: "_blank"
  // }
];
